import { GridCellProps } from '@progress/kendo-react-grid';
import { MouseEvent, useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import useRedirect from 'src/hooks/useRedirect';

const AttachedInvoiceCell = (props: GridCellProps) => {
  const { getUrl, redirect } = useRedirect();
  const { handleCellClick } = useInvoiceScanManager();

  const field = props.field || '';
  const value = props.dataItem[field];
  const id = props.dataItem.receiptId;

  const handleClickRedirect = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      const url = getUrl('invoiceDetails')(id, props.dataItem.poId);
      redirect(url, false, true);
    },
    [getUrl, id, props.dataItem.poId, redirect]
  );

  const handleClick = useCallback(() => {
    handleCellClick(props.dataItem.attachId);
  }, [handleCellClick, props.dataItem.attachId]);

  const displayValue = useMemo(() => {
    if (props.dataItem.receiptId === null) {
      return 'N/A';
    } else {
      return value === null ? 'Unassigned' : value;
    }
  }, [props.dataItem.receiptId, value]);

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} title={displayValue} onClick={handleClick}>
      {props.dataItem.receiptId === null ? (
        <span className="cursor-default">{displayValue}</span>
      ) : (
        <button onClick={handleClickRedirect} className="text-link cursor-pointer underline">
          {displayValue}
        </button>
      )}
    </GridCellBase>
  );
};

export default AttachedInvoiceCell;
